module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Topbar'), _vm._v(" "), _c('fieldset', {
    staticClass: "signin-form"
  }, [_c('legend', [_vm._v("Sign in")]), _vm._v(" "), _c('button', {
    staticClass: "google-btn",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.signinGoogle()
      }
    }
  }, [_c('img', {
    staticClass: "idp-btn-img",
    attrs: {
      "src": "/static/img/icons/google-g-logo.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idp-btn-text"
  }, [_vm._v("\n        sign in with google\n      ")])]), _vm._v(" "), _c('h4', [_vm._v("or using your e-mail")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.signin.apply(null, arguments)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "signin-email"
    }
  }, [_vm._v("E-Mail")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "email",
      "id": "signin-email",
      "placeholder": "tom@aol.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "signin-pw"
    }
  }, [_vm._v("Password")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "password",
      "id": "signin-pw",
      "placeholder": "**************",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button acc",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign in")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Forgot your password?\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'pwreset'
      }
    }
  }, [_vm._v("Reset Password")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Have no account?\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_vm._v("Sign up")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d349699","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signin.vue
// module id = 285
// module chunks = 1